var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3817_57033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.25 80.5C160.25 124.7 124.45 160.5 80.25 160.5C36.05 160.5 0.25 124.7 0.25 80.5C0.25 36.3 36.05 0.5 80.25 0.5C124.45 0.5 160.25 36.3 160.25 80.5Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35 50.5001C61.55 48.6001 63.05 47.3001 64.55 47.3001H72.75C74.15 47.3001 74.95 48.2001 75.35 49.3001L77.35 56.8001C77.35 56.8001 84.55 45.6001 95.25 45.6001C101.05 45.6001 105.35 47.5001 106.85 48.8001C108.05 49.8001 108.25 51.2001 107.15 52.7001L96.75 67.2001C95.75 68.7001 94.35 68.9001 93.35 68.4001C92.65 68.1001 91.65 67.7001 90.25 67.7001C86.65 67.7001 82.75 71.1001 81.85 76.9001L76.95 112.2C76.65 114.2 75.95 115.4 73.15 115.4H54.95C53.45 115.4 52.25 113.9 52.55 112.2L61.25 50.5001H61.35Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3817_57033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/LogoTransparent.1ddf66377512c67a2cbc8bf0512bcb5f.svg";
export { ForwardRef as ReactComponent };